import React from "react";
import { Text, View } from "react-native";

import { colors, radius } from "./theme";

// A small brand-coloured counter for "new" things (What's new). Renders
// nothing at 0; above `max` it shows "99+". The white ring keeps it readable
// where it overlaps an icon.
//
//   <CountBadge count={3} />            next to a label or in a row
//   <CountBadge count={3} overlay />    on the top-right corner of an icon
const CountBadge = ({ count, max = 99, overlay = false, style }) => {
  if (!count || count < 1) return null;
  const label = count > max ? `${max}+` : String(count);
  return (
    <View
      accessible={false}
      importantForAccessibility="no-hide-descendants"
      style={[
        {
          minWidth: 18,
          height: 18,
          paddingHorizontal: label.length > 1 ? 5 : 0,
          borderRadius: radius.pill,
          backgroundColor: colors.brand,
          borderWidth: 1.5,
          borderColor: colors.white,
          alignItems: "center",
          justifyContent: "center",
        },
        overlay && { position: "absolute", top: -6, right: -9 },
        style,
      ]}
    >
      <Text
        style={{
          color: colors.white,
          fontSize: 11,
          lineHeight: 14,
          fontWeight: "700",
        }}
      >
        {label}
      </Text>
    </View>
  );
};

export default CountBadge;
